// ReferralProgramPage.jsx
// Standalone referral program experience.

import React from "react";
import { SoyTiendaHeader } from "./shared/SoyTiendaHeader";
import { MarketplaceFooter } from "./shared/MarketplaceFooter";
import { WhatsAppFloat } from "./shared/WhatsAppFloat";
import { ReferidosSection } from "./tienda/ReferidosSection";

export default function ReferralProgramPage() {
  return (
    <div className="flex min-h-screen flex-col bg-white font-sans antialiased text-slate-900">
      <SoyTiendaHeader />
      <main className="flex-1">
        <ReferidosSection />
      </main>
      <MarketplaceFooter />
      <WhatsAppFloat />
    </div>
  );
}
